import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import Constants from "data/Constants";
import { useFormik } from "formik";
import * as yup from "yup";
import Utils from "utils/index";
import { updateMentorQuestion } from "services/mentor.service";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function EditQuestionDialog(props) {
  var { question, onClose, onChange } = props;

  const questionData = {
    ...question,
  };

  const validationSchema = yup.object({
    answer: yup.string().label("Answer").min(1).max(1000),
  });

  const formik = useFormik({
    initialValues: questionData,
    validationSchema,
    onSubmit: (values) => {
      // send question

      updateMentorQuestion(question._id, {
        answer: values.answer,
      });

      onChange({
        ...question,
        answer: values.answer,
      });

      onClose();
    },
  });

  return (
    question && (
      <Dialog
        open={question ? true : false}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1} className="font-extrabold text-lg">
                Question
              </Box>
              <Box>
                <IconButton onClick={onClose}>
                  <IoCloseOutline />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <div className="grid" style={{ minWidth: "450px" }}>
              <h1 className="font-bold my-4 p-1">{question.question}</h1>
              <TextField
                label="Answer"
                variant="filled"
                size="small"
                name="answer"
                value={formik.values.answer}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.answer && Boolean(formik.errors.answer)}
                helperText={formik.touched.answer && formik.errors.answer}
                multiline
                rows={5}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button size="small" onClick={onClose}>
              Cancel
            </Button>
            <Button size="small" type="submit">
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  );
}

export default EditQuestionDialog;
